import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { CONF, Conf, RouterFacade, TileFacade, TileRouter } from '@contact/upgrade';

@Injectable({
  providedIn: 'root',
})
export class WallboardRouter extends TileRouter {
  constructor(
    @Inject(CONF) protected override readonly conf: Conf,
    protected override readonly router: Router,
    protected override readonly routerFacade: RouterFacade,
    protected override readonly tileFacade: TileFacade
  ) {
    super(conf, router, routerFacade, tileFacade);
  }
}
